import { render, staticRenderFns } from "./form-code.vue?vue&type=template&id=32440e58&scoped=true&"
import script from "./form-code.vue?vue&type=script&lang=js&"
export * from "./form-code.vue?vue&type=script&lang=js&"
import style0 from "./form-code.vue?vue&type=style&index=0&id=32440e58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/172.26.59.72+4873+vue-loader@15.10.1_6sfbhgu6kjcmlhpjwryimz4q4m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32440e58",
  null
  
)

export default component.exports